import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import ContactForm from "./sections/ContactForm";
import ContactInformation from "./sections/ContactInformation";
import Karta from "./sections/Karta";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <ContactForm />
      <ContactInformation />
      <Karta />
      <Footer />
    </div>;
}